


<template>
<div class="news-pullout pullout-panel">
  <div class="bkg"></div>
  <div class="news-list">


    <div class="news-scroll">
      <img class="w-full" src="/img/screens/admin-news.png?v=10122022" />
      <div class="links">



        <screen-link left="85%" top="1%" width="13%" height="4%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>

      </div>
    </div>

  </div>



</div>
</template>

<script>
import ScreenLink from "@/components/ScreenLink";
export default {
    name: "news-pullout",
  components: {ScreenLink},
  props: {},
    data: function(){
        return {
          detailPanel: null
        }
        },
    mounted() {
      if(this.$route.query.level !== undefined){
        this.detailPanel = this.$route.query.level;
      }
    },

    watch: {
      $route: function(next){
        if(next.query.level !== undefined){
          this.detailPanel = next.query.level;
        }
      }
    },

    methods: {
      showDetails: function(e){
          this.detailPanel = e.target.dataset.tgt;
let query = {...this.$route.query};
          query.level=e.target.dataset.tgt;
          this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query });
      }
    },
    computed: {}
}
</script>

<style scoped>


.news-pullout {
  width: 100%;
  position: absolute;
  top: calc((60/920) * 100%);
  height: calc(((920 - 60)/920) * 100%);

}

.news-pullout .bkg {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: black;
  opacity: 0.4;
}

.news-pullout img {
  display: block;
}

.news-pullout bkg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 0.4;

}

.news-list {

  position: absolute;
  width: calc((320/1580) * 100%);
  height: 100%;

  right: 0;
  display: flex;
  flex-direction: column;

}



.news-scroll {
  position: relative;

  overflow-y: scroll;
}

.w-full {
  width: 100%;
}

</style>